// Same numeric price in both markets: 34,90 € for FR, $34.90 for EN.
export const currencyFor = (locale) => (locale === "fr" ? "eur" : "usd");

export const money = (amount, locale, decimals) => {
  const n = Number(amount || 0);
  const d = decimals === undefined ? (n % 1 ? 2 : 0) : decimals;
  return locale === "fr" ? `${n.toFixed(d).replace(".", ",")} €` : `$${n.toFixed(d)}`;
};

export const moneySymbol = (locale) => (locale === "fr" ? "€" : "$");
